import { Outlet } from "@tanstack/react-router"
import type { ReactNode } from "react"
import { ThemeComponent } from "./ThemeComponent"
import {
  ApiContextProvider,
  CountrySelectionContextProvider,
  OauthAuthorizeContextProvider,
  useOauthAuthorizeContext,
  useCountrySelectionContext,
} from "src/contexts"
import { TrackingTechnologyConsent } from "src/pages"

interface Props {
  children?: ReactNode;
}

function OauthCountrySelectionContextProvider(props: Props) {
  const { country_code } = useOauthAuthorizeContext()

  return (
    <CountrySelectionContextProvider oauthCountryCode={country_code}>
      {props.children}
    </CountrySelectionContextProvider>
  )
}

function OauthApiContextProvider(props: Props) {
  const { country } = useCountrySelectionContext()

  return (
    <ApiContextProvider baseURL={country?.sugarmate_api_base_url}>
      {props.children}
    </ApiContextProvider>
  )
}

/*
 * this passes the tracking technology consent response parameters from the url
 * to the TrackingTechnologyConsent component
 */
function OauthTrackingTechnologyConsent(props: Props) {
  const {
    tracking_technology_consent_response_value,
    tracking_technology_consent_response_updated_at,
  } = useOauthAuthorizeContext()

  return (
    <TrackingTechnologyConsent
      responseValue={tracking_technology_consent_response_value}
      responseUpdatedAt={tracking_technology_consent_response_updated_at}
    >
      {props.children}
    </TrackingTechnologyConsent>
  )
}

export function OauthAuthorizeRootComponent() {
  return (
    <ThemeComponent>
      <OauthAuthorizeContextProvider>
        <OauthTrackingTechnologyConsent>
          <OauthCountrySelectionContextProvider>
            <OauthApiContextProvider>
              <Outlet />
            </OauthApiContextProvider>
          </OauthCountrySelectionContextProvider>
        </OauthTrackingTechnologyConsent>
      </OauthAuthorizeContextProvider>
    </ThemeComponent>
  )
}
